import { DateUtil, Divider, Switch } from '@aon/aon-tws-common-ui';
import _ from 'lodash';
import * as React from 'react';
import styled from 'styled-components';
import ContentConstants from '../../../../contentConstants';
import { DistributionType, IParticipationCountsVm } from '../../../../models';
import { ClearDiv } from '../../../common';
import { ParticipationMonitorTableColumn } from './ParticipationMonitorTableColumn';

export interface IParticipationMonitorTableProps {
	participationCounts: IParticipationCountsVm;
	distributionType: DistributionType;
	includePartialCompletes: boolean;
	toggleIncludePartialCompletes: () => boolean;
}

const MonitorTableWrapper = styled.div`
	flex-grow: 1;
`;

export class ParticipationMonitorTable extends React.PureComponent<IParticipationMonitorTableProps> {
	public render() {
		const { distributionType } = this.props;
		const hasChart = distributionType === DistributionType.SingleLink;

		return (
			<MonitorTableWrapper>
				<ClearDiv clearHeight={'20px'} />
				<ParticipationMonitorTableColumn
					adjustLayoutForChart={hasChart}
					fontSize={'xl'}
					label={ContentConstants.PARTICIPATION_MONITOR_COMPLETED}
				>
					<span className={'tws-participation-monitor-complete-count'}>
						{this.props.includePartialCompletes
							? this.props.participationCounts.completeCount + this.props.participationCounts.partialCompleteCount
							: this.props.participationCounts.completeCount}
					</span>
				</ParticipationMonitorTableColumn>
				{distributionType !== DistributionType.SingleLinkWithoutDistribution && distributionType !== DistributionType.GroupBasedLinks && (
					<ParticipationMonitorTableColumn
						adjustLayoutForChart={hasChart}
						fontSize={'xl'}
						label={ContentConstants.PARTICIPATION_MONITOR_INVITED}
					>
						<span className={'tws-participation-monitor-invited-count'}>{this.props.participationCounts.invitedCount}</span>
					</ParticipationMonitorTableColumn>
				)}
				<ClearDiv clearHeight={'14px'} />

				<ParticipationMonitorTableColumn adjustLayoutForChart={hasChart}>
					<Divider type={'dashed'} />
				</ParticipationMonitorTableColumn>

				<ClearDiv clearHeight={'14px'} />
				<ParticipationMonitorTableColumn adjustLayoutForChart={hasChart} label={ContentConstants.PARTICIPATION_MONITOR_PARTIAL_COMPLETES}>
					<span className={'tws-participation-monitor-partially-complete-count'}>
						{this.props.participationCounts.partialCompleteCount}
					</span>
				</ParticipationMonitorTableColumn>
				<ParticipationMonitorTableColumn
					adjustLayoutForChart={hasChart}
					label={ContentConstants.PARTICIPATION_MONITOR_INCLUDE_PARTIAL_COMPLETES}
				>
					<Switch checked={this.props.includePartialCompletes} getValue={(e: any) => this.props.toggleIncludePartialCompletes()} />
				</ParticipationMonitorTableColumn>
				<ClearDiv clearHeight={'14px'} />

				<ParticipationMonitorTableColumn adjustLayoutForChart={hasChart}>
					<Divider type={'dashed'} />
				</ParticipationMonitorTableColumn>

				<ClearDiv clearHeight={'14px'} />
				<ParticipationMonitorTableColumn adjustLayoutForChart={hasChart} label={ContentConstants.PARTICIPATION_MONITOR_DATA_AS_OF}>
					<span className={'tws-participation-monitor-generation-date'}>
						{DateUtil.formatDateToLocal(new Date(this.props.participationCounts.generationDate))}
					</span>
				</ParticipationMonitorTableColumn>
			</MonitorTableWrapper>
		);
	}
}
